module.exports = {"id":"46175","name":"Markus Rosenberg","rating":"73","photo":"./data/images/photos/0/46175.png","club":{"name":"Malmö FF","logo":"./data/images/clubs/MalmoFF.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarkusRosenberg0.json
// module id = 2801
// module chunks = 0